import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reorderTodos } from '../api/reorderApi';
import { useUser } from '../contexts/UserContext';

export const useReorderTodos = () => {
  const queryClient = useQueryClient();
  const { currentUser } = useUser();

  // Accepts todoIds and optionally listId for more robust backend support
  return useMutation({
    mutationFn: ({ todoIds, listId }: { todoIds: number[]; listId?: number }) =>
      reorderTodos(todoIds, currentUser?.email || '', listId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['todos', currentUser?.email] });
      queryClient.invalidateQueries({ queryKey: ['todolists', currentUser?.email] });
    },
  });
};
